export const projects = [
  {
    id: 4,
    title: 'KlymeUpp',
    description: {
      nl: 'Gamified platform voor loopbaanontwikkeling waar jongeren skills ontwikkelen, badges verdienen en de baan vinden die bij ze past. Next.js frontend met een eigen FastAPI- en PostgreSQL-backend.',
      en: 'Gamified career-development platform where young people build skills, earn badges and find the job that fits them. Next.js frontend with a custom FastAPI and PostgreSQL backend.',
    },
    tags: ['Next.js', 'FastAPI', 'PostgreSQL', 'Docker', 'Tailwind CSS'],
    gradient: 'gradient-1',
    src: '/assets/images/KlymeUpp.png',
    url: 'https://klymeupp.nl',
    category: 'web',
    featured: true,
  },
  {
    id: 1,
    title: 'Sacre',
    description: {
      nl: 'Een volledige e-commerce oplossing met een robuust backend-systeem voor productbeheer, veilige betalingsintegratie en real-time voorraadbeheer. Ontwikkeld met een focus op schaalbaarheid en een naadloze gebruikerservaring.',
      en: 'A complete e-commerce solution with a robust backend system for product management, secure payment integration and real-time inventory management. Built with a focus on scalability and a seamless user experience.',
    },
    tags: ['Vue', 'Spring Boot', 'Docker', 'PostgreSQL'],
    gradient: 'gradient-2',
    src: '/assets/images/Sacre.png',
    url: 'https://www.scentsofsacre.com/',
    category: 'web',
    featured: true,
  },
  {
    id: 3,
    title: 'RechtVooruit',
    description: {
      nl: 'Juridisch platform waar particulieren eenvoudig juridische diensten kunnen aanvragen en betalen. Gebouwd met een Vue frontend, Spring Boot backend en Mollie betalingsintegratie.',
      en: 'Legal services platform where individuals can easily request and pay for legal services. Built with a Vue frontend, Spring Boot backend and Mollie payment integration.',
    },
    tags: ['Vue', 'Vite', 'Spring Boot', 'PostgreSQL', 'Docker', 'Mollie', 'Resend'],
    gradient: 'gradient-3',
    src: '/assets/images/Rechtvooruit.png',
    url: 'https://rechtvooruit.com',
    category: 'web',
    featured: true,
  },
  {
    id: 5,
    title: 'Solvey',
    description: {
      nl: 'Op maat gebouwde Shopify-storefront voor een merk in vrouwelijke gezondheid. Wetenschappelijk onderbouwde supplementen, met een interactieve quiz en conversiegerichte productpagina\'s.',
      en: 'Custom-built Shopify storefront for a women\'s health brand. Science-based supplements, with an interactive quiz and conversion-focused product pages.',
    },
    tags: ['Shopify', 'Liquid', 'JavaScript', 'CSS'],
    gradient: 'gradient-1',
    src: '/assets/images/SolveyFem.png',
    url: 'https://solveyfem.com',
    category: 'web',
    featured: false,
  },
  {
    id: 2,
    title: 'Belastinghelp',
    description: {
      nl: 'Een applicatie die complexe financiële data toegankelijk maakt. Bevat beveiligde authenticatie, een gedetailleerd overzicht van transactiegeschiedenis en real-time notificaties voor statusupdates.',
      en: 'An application that makes complex financial data accessible. Features secure authentication, a detailed transaction history overview and real-time notifications for status updates.',
    },
    tags: ['React Native', 'Spring Boot', 'JWT'],
    gradient: 'gradient-2',
    src: '/assets/images/BelastingHelp.png',
    url: 'https://belastinghelp.nl/',
    category: 'web',
    featured: false,
  },
  {
    id: 7,
    title: 'CarPlug Dashboard',
    description: {
      nl: 'Intern beheersysteem voor een autoverhuurbedrijf: reserveringen, vloot, klanten en facturatie samengebracht in één overzichtelijk dashboard. Gebouwd met Next.js en Supabase.',
      en: 'Internal management system for a car rental business: bookings, fleet, customers and invoicing brought together in one clear dashboard. Built with Next.js and Supabase.',
    },
    tags: ['Next.js', 'Supabase', 'Tailwind CSS', 'TypeScript'],
    gradient: 'gradient-3',
    src: '/assets/images/CarPlug.png',
    category: 'web',
    featured: false,
  },
  {
    id: 6,
    title: 'Java Jam',
    description: {
      nl: 'One pager voor een Java event voor Sopra Steria. Strak, snel en volledig op maat gebouwd.',
      en: 'One pager for a Java event for Sopra Steria. Sharp, fast and fully custom built.',
    },
    tags: ['Svelte', 'REST API'],
    gradient: 'gradient-1',
    src: '/assets/images/JavaJam.png',
    url: 'https://java-jam.nl/',
    category: 'web',
    featured: false,
  },
]

export const featuredProjects = projects.filter((p) => p.featured)
